export default "__VITE_ASSET__Bh20YxSx__"